<template>
  <div>
    <v-row>
      <v-col cols="1">
        <v-btn
          outlined
          icon
          x-large
          @click="showPayment()"
        >
          <v-icon> {{ icons.mdiChevronLeft }}</v-icon>
        </v-btn>
      </v-col>
      <v-col>
        <span class="title">
          <h2>Separar Pagamento</h2>
        </span>
      </v-col>
      <!-- <v-col cols="1">
            <v-btn outlined icon color="primary" x-large>
                <v-icon> {{ icons.mdiCog }}</v-icon>
            </v-btn>
        </v-col> -->
    </v-row>
    <!-- EMPRESA  -->
    <v-row v-if="getCompany">
      <v-col>
        <v-card
          outlined
          :class="{ card_selected: getSelectecResposible.origin == 'company' && !getSelectecResposible.is_custom && getSelectecResposible.id == getCompany.id }"
          @click="setResponsibleCompany(getCompany)"
        >
          <v-card-title>
            {{ getCompany ? getCompany.fantasy_name : '' }}
          </v-card-title>
          <v-card-text>
            <v-row
              v-for="(item, index) in itemsSelectedCompany "
              :key="index"
            >
              <v-col class="">
                </b>
                {{ item.description }}
                </b>
              </v-col>
              <v-col
                cols="3"
                class="text-right"
              >
                {{ formatMoney(item.sale_price*item.pivot.quantity) }}
              </v-col>
            </v-row>
            <v-row>
              <v-col class="text">
                Impostos
              </v-col>
              <v-col class=" text text-right">
                {{ formatMoney(sumISSCompany) }}
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-card
                  v-for="payment in getpaymentMethodsSeparate"
                  :key="payment.method"
                  class="mb-2"
                >
                  <v-card-text v-if="payment.method == 'money' && payment.origin == 'company' && payment.id == getCompany.id">
                    <v-row>
                      <v-col>
                        <v-icon
                          color="success"
                          large
                        >
                          {{ icons.mdiCash }}
                        </v-icon>
                        <span class="text mt-4"> Dinheiro</span>
                      </v-col>
                      <v-col class="text-right">
                        <span class="text mt-4"> R$ {{ formatMoney(payment.value) }}</span>
                        <v-btn
                          class="ml-3"
                          icon
                          @click="removePayment(payment)"
                        >
                          <v-icon color="secondary">
                            {{ icons.mdiTrashCanOutline }}
                          </v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-text>

                  <v-card-text
                    v-if="payment.method == 'pix' && payment.origin == 'company' && payment.id == getCompany.id"
                    class="mb-2"
                  >
                    <v-row>
                      <div class="log_pix mt-2 ml-3">
                        <img
                          width="40"
                          src="@/assets/images/logos/logo-pix.png"
                          alt=""
                        >
                      </div>
                      <div
                        class="text_method_pix mt-4 ml-1"
                        style="font-size:large"
                      >
                        <span>Pix</span>
                      </div>
                      <v-col class="text-right">
                        <span class="text "> R$ {{ formatMoney(payment.value) }}</span>
                        <v-btn
                          class="ml-3"
                          icon
                          @click="removePayment(payment)"
                        >
                          <v-icon color="secondary">
                            {{ icons.mdiTrashCanOutline }}
                          </v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-text>

                  <v-card-text
                    v-if="payment.method == 'credit_card' && payment.origin == 'company' && payment.id == getCompany.id"
                    class="mb-2"
                  >
                    <v-row>
                      <v-col>
                        <v-icon
                          color="primary"
                          large
                        >
                          {{ icons.mdiCreditCard }}
                        </v-icon>
                        <span class="text mt-4"> Cartão de Crédito</span>
                      </v-col>
                      <v-col class="text-right">
                        <span class="text mt-4"> R$ {{ formatMoney(payment.value) }}</span>
                        <v-btn
                          class="ml-3"
                          icon
                          @click="removePayment(payment)"
                        >
                          <v-icon color="secondary">
                            {{ icons.mdiTrashCanOutline }}
                          </v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-text>

                  <v-card-text
                    v-if="payment.method == 'debit_card' && payment.origin == 'company' && payment.id == getCompany.id"
                    class="mb-2"
                  >
                    <v-row>
                      <v-col>
                        <v-icon
                          color="success"
                          large
                        >
                          {{ icons.mdiCreditCard }}
                        </v-icon>
                        <span class="text mt-4"> Cartão de Débito</span>
                      </v-col>
                      <v-col class="text-right">
                        <span class="text mt-4"> R$ {{ formatMoney(payment.value) }}</span>
                        <v-btn
                          class="ml-3"
                          icon
                          @click="removePayment(payment)"
                        >
                          <v-icon color="secondary">
                            {{ icons.mdiTrashCanOutline }}
                          </v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-text>

                  <v-card-text
                    v-if="payment.method == 'invoice' && payment.origin == 'company' && payment.id == getCompany.id"
                    class="mb-2"
                  >
                    <v-row>
                      <v-col>
                        <v-icon
                          color="primary"
                          large
                        >
                          {{ icons.mdiCalendarClock }}
                        </v-icon>
                        <span class="text mt-4"> Faturado</span>
                      </v-col>
                      <v-col class="text-right">
                        <span class="text mt-4"> R$ {{ formatMoney(payment.value) }}</span>
                        <v-btn
                          class="ml-3"
                          icon
                          @click="removePayment(payment)"
                        >
                          <v-icon color="secondary">
                            {{ icons.mdiTrashCanOutline }}
                          </v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-text>

                  <v-card-text
                    v-if="payment.method == 'other' && payment.origin == 'company' && payment.id == getCompany.id"
                    class="mb-2"
                  >
                    <v-row>
                      <v-col>
                        <v-icon
                          color="error"
                          large
                        >
                          {{ icons.mdiCashMultiple }}
                        </v-icon>
                        <span class="text mt-4"> Outros</span>
                      </v-col>
                      <v-col class="text-right">
                        <span class="text "> R$ {{ formatMoney(payment.value) }}</span>
                        <v-btn
                          class="ml-3"
                          icon
                          @click="removePayment(payment)"
                        >
                          <v-icon color="secondary">
                            {{ icons.mdiTrashCanOutline }}
                          </v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-row v-if="sumItemsSelectedCompany > 0">
              <v-col class="text-center mt-6">
                <v-btn
                  elevation="0"
                  class="btn-text"
                  x-large
                  color="primary"
                  @click="dialog = true"
                >
                  <v-icon>{{ icons.mdiPlusCircleOutline }}</v-icon> &nbsp Adicionar Forma de pagamento -
                  &nbsp <b> R$ {{ formatMoney(sumItemsSelectedCompany) }} a pagar</b>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <v-row
      v-for="(guest, index) in getGuests"
      :key="index"
    >
      <v-col>
        <v-card
          outlined
          :class="{ card_selected: (getSelectecResposible.origin == 'guest' && !getSelectecResposible.is_custom && getSelectecResposible.id == guest.id) }"
          @click="setResponsibleGuest(guest)"
        >
          <v-card-title>
            {{ guest.name }}
          </v-card-title>
          <v-card-text>
            <v-row
              v-for="(item, index) in itemsSelectedGuests(guest.id) "
              :key="index"
            >
              <v-col>
                {{ item.description }}
              </v-col>
              <v-col class="text-right">
                {{ formatMoney(item.sale_price*item.pivot.quantity) }}
              </v-col>
            </v-row>
            <v-row>
              <v-col class="text">
                Impostos
              </v-col>
              <v-col class=" text text-right">
                {{ formatMoney(sumISSPerGuests(guest.id)) }}
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-card
                  v-for="payment in getpaymentMethodsSeparate"
                  :key="payment.method"
                >
                  <v-card-text
                    v-if="payment.method == 'money' && payment.origin == 'guest' && payment.id == guest.id"
                  >
                    <v-row>
                      <v-col>
                        <v-icon
                          color="success"
                          large
                        >
                          {{ icons.mdiCash }}
                        </v-icon>
                        <span class="text mt-4"> Dinheiro</span>
                      </v-col>
                      <v-col class="text-right">
                        <span class="text mt-4"> R$ {{ formatMoney(payment.value) }}</span>
                        <v-btn
                          class="ml-3"
                          icon
                          @click="removePayment(payment)"
                        >
                          <v-icon color="secondary">
                            {{ icons.mdiTrashCanOutline }}
                          </v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-text>

                  <v-card-text
                    v-if="payment.method == 'pix' && payment.origin == 'guest' && payment.id == guest.id"
                  >
                    <v-row>
                      <div class="log_pix mt-2 ml-3">
                        <img
                          width="40"
                          src="@/assets/images/logos/logo-pix.png"
                          alt=""
                        >
                      </div>
                      <div
                        class="text_method_pix mt-4 ml-1"
                        style="font-size:large"
                      >
                        <span>Pix</span>
                      </div>
                      <v-col class="text-right">
                        <span class="text "> R$ {{ formatMoney(payment.value) }}</span>
                        <v-btn
                          class="ml-3"
                          icon
                          @click="removePayment(payment)"
                        >
                          <v-icon color="secondary">
                            {{ icons.mdiTrashCanOutline }}
                          </v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-text
                    v-if="payment.method == 'credit_card' && payment.origin == 'guest' && payment.id == guest.id"
                    class="mb-2"
                  >
                    <v-row>
                      <v-col>
                        <v-icon
                          color="primary"
                          large
                        >
                          {{ icons.mdiCreditCard }}
                        </v-icon>
                        <span class="text mt-4"> Cartão de Crédito</span>
                      </v-col>
                      <v-col class="text-right">
                        <span class="text mt-4"> R$ {{ formatMoney(payment.value) }}</span>
                        <v-btn
                          class="ml-3"
                          icon
                          @click="removePayment(payment)"
                        >
                          <v-icon color="secondary">
                            {{ icons.mdiTrashCanOutline }}
                          </v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-text>

                  <v-card-text
                    v-if="payment.method == 'debit_card' && payment.origin == 'guest' && payment.id == guest.id"
                    class="mb-2"
                  >
                    <v-row>
                      <v-col>
                        <v-icon
                          color="success"
                          large
                        >
                          {{ icons.mdiCreditCard }}
                        </v-icon>
                        <span class="text mt-4"> Cartão de Débito</span>
                      </v-col>
                      <v-col class="text-right">
                        <span class="text mt-4"> R$ {{ formatMoney(payment.value) }}</span>
                        <v-btn
                          class="ml-3"
                          icon
                          @click="removePayment(payment)"
                        >
                          <v-icon color="secondary">
                            {{ icons.mdiTrashCanOutline }}
                          </v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-text
                    v-if="payment.method == 'invoice' && payment.origin == 'guest' && payment.id == guest.id"
                    class="mb-2"
                  >
                    <v-row>
                      <v-col>
                        <v-icon
                          color="primary"
                          large
                        >
                          {{ icons.mdiCalendarClock }}
                        </v-icon>
                        <span class="text mt-4"> Faturado</span>
                      </v-col>
                      <v-col class="text-right">
                        <span class="text mt-4"> R$ {{ formatMoney(payment.value) }}</span>
                        <v-btn
                          class="ml-3"
                          icon
                          @click="removePayment(payment)"
                        >
                          <v-icon color="secondary">
                            {{ icons.mdiTrashCanOutline }}
                          </v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-text
                    v-if="payment.method == 'other' && payment.origin == 'guest' && payment.id == guest.id"
                  >
                    <v-row>
                      <v-col>
                        <v-icon
                          color="error"
                          large
                        >
                          {{ icons.mdiCashMultiple }}
                        </v-icon>
                        <span class="text mt-4"> Outros</span>
                      </v-col>
                      <v-col class="text-right">
                        <span class="text "> R$ {{ formatMoney(payment.value) }}</span>
                        <v-btn
                          class="ml-3"
                          icon
                          @click="removePayment(payment)"
                        >
                          <v-icon color="secondary">
                            {{ icons.mdiTrashCanOutline }}
                          </v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-row v-if="sumItemsSelectedGuests(guest.id) > 0">
              <v-col class="text-center mt-6">
                <v-btn
                  elevation="0"
                  class="btn-text"
                  x-large
                  color="primary"
                  @click="dialog = true"
                >
                  <v-icon>{{ icons.mdiPlusCircleOutline }}</v-icon> &nbsp Adicionar Forma de pagamento -
                  &nbsp <b> R$ {{ formatMoney(sumItemsSelectedGuests(guest.id)) }} a pagar</b>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <!-- CARDS DOS RESPONSÁVEIS CUSTOMIZADOS -->
    <v-row
      v-for="(customResp, index) in customResponsibles"
      :key="'custom-' + index"
    >
      <v-col>
        <v-card
          outlined
          :class="{card_selected:(getSelectecResposible.id == customResp.id && getSelectecResposible.origin == customResp.origin && getSelectecResposible.is_custom)}"
          @click="setResponsibleCustom(customResp)"
        >
          <v-card-title>
            <v-icon
              left
              small
              color="warning"
            >
              {{ icons.mdiStarCircle }}
            </v-icon>
            {{ customResp.name || customResp.fantasy_name }}
            <v-chip
              x-small
              class="ml-2"
              color="warning"
            >
              PERSONALIZADO
            </v-chip>
            <v-spacer></v-spacer>
            <v-btn
              icon
              small
              @click.stop="removeCustomResponsible(index)"
            >
              <v-icon color="error">
                {{ icons.mdiDelete }}
              </v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-row
              v-for="(item,idx) in itemsSelectedCustom(customResp.id, customResp.origin) "
              :key="idx"
            >
              <v-col>
                {{ item.description }}
              </v-col>
              <v-col class="text-right">
                {{ formatMoney(item.sale_price*item.pivot.quantity) }}
              </v-col>
            </v-row>
            <v-row>
              <v-col class="text">
                Impostos
              </v-col>
              <v-col class=" text text-right">
                {{ formatMoney(sumISSCustom(customResp.id, customResp.origin)) }}
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-card
                  v-for="payment in getpaymentMethodsSeparate"
                  :key="payment.method"
                >
                  <v-card-text v-if="payment.method == 'money' && payment.origin == customResp.origin && payment.id == customResp.id ">
                    <v-row>
                      <v-col>
                        <v-icon
                          color="success"
                          large
                        >
                          {{ icons.mdiCash }}
                        </v-icon>
                        <span class="text mt-4"> Dinheiro</span>
                      </v-col>
                      <v-col class="text-right">
                        <span class="text mt-4"> R$ {{ formatMoney(payment.value) }}</span>
                        <v-btn
                          class="ml-3"
                          icon
                          @click="removePayment(payment)"
                        >
                          <v-icon color="secondary">
                            {{ icons.mdiTrashCanOutline }}
                          </v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-text>

                  <v-card-text v-if="payment.method == 'pix' && payment.origin == customResp.origin && payment.id == customResp.id ">
                    <v-row>
                      <div class="log_pix mt-2 ml-3">
                        <img
                          width="40"
                          src="@/assets/images/logos/logo-pix.png"
                          alt=""
                        >
                      </div>
                      <div
                        class="text_method_pix mt-4 ml-1"
                        style="font-size:large"
                      >
                        <span>Pix</span>
                      </div>
                      <v-col class="text-right">
                        <span class="text "> R$ {{ formatMoney(payment.value) }}</span>
                        <v-btn
                          class="ml-3"
                          icon
                          @click="removePayment(payment)"
                        >
                          <v-icon color="secondary">
                            {{ icons.mdiTrashCanOutline }}
                          </v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-text
                    v-if="payment.method == 'credit_card' && payment.origin == customResp.origin && payment.id == customResp.id"
                    class="mb-2"
                  >
                    <v-row>
                      <v-col>
                        <v-icon
                          color="primary"
                          large
                        >
                          {{ icons.mdiCreditCard }}
                        </v-icon>
                        <span class="text mt-4"> Cartão de Crédito</span>
                      </v-col>
                      <v-col class="text-right">
                        <span class="text mt-4"> R$ {{ formatMoney(payment.value) }}</span>
                        <v-btn
                          class="ml-3"
                          icon
                          @click="removePayment(payment)"
                        >
                          <v-icon color="secondary">
                            {{ icons.mdiTrashCanOutline }}
                          </v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-text>

                  <v-card-text
                    v-if="payment.method == 'debit_card' && payment.origin == customResp.origin && payment.id == customResp.id"
                    class="mb-2"
                  >
                    <v-row>
                      <v-col>
                        <v-icon
                          color="success"
                          large
                        >
                          {{ icons.mdiCreditCard }}
                        </v-icon>
                        <span class="text mt-4"> Cartão de Débito</span>
                      </v-col>
                      <v-col class="text-right">
                        <span class="text mt-4"> R$ {{ formatMoney(payment.value) }}</span>
                        <v-btn
                          class="ml-3"
                          icon
                          @click="removePayment(payment)"
                        >
                          <v-icon color="secondary">
                            {{ icons.mdiTrashCanOutline }}
                          </v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-text
                    v-if="payment.method == 'invoice' && payment.origin == customResp.origin && payment.id == customResp.id"
                    class="mb-2"
                  >
                    <v-row>
                      <v-col>
                        <v-icon
                          color="primary"
                          large
                        >
                          {{ icons.mdiCalendarClock }}
                        </v-icon>
                        <span class="text mt-4"> Faturado</span>
                      </v-col>
                      <v-col class="text-right">
                        <span class="text mt-4"> R$ {{ formatMoney(payment.value) }}</span>
                        <v-btn
                          class="ml-3"
                          icon
                          @click="removePayment(payment)"
                        >
                          <v-icon color="secondary">
                            {{ icons.mdiTrashCanOutline }}
                          </v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-text v-if="payment.method == 'other' && payment.origin == customResp.origin && payment.id == customResp.id ">
                    <v-row>
                      <v-col>
                        <v-icon
                          color="error"
                          large
                        >
                          {{ icons.mdiCashMultiple }}
                        </v-icon>
                        <span class="text mt-4"> Outros</span>
                      </v-col>
                      <v-col class="text-right">
                        <span class="text "> R$ {{ formatMoney(payment.value) }}</span>
                        <v-btn
                          class="ml-3"
                          icon
                          @click="removePayment(payment)"
                        >
                          <v-icon color="secondary">
                            {{ icons.mdiTrashCanOutline }}
                          </v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-row v-if="sumItemsSelectedCustom(customResp.id, customResp.origin) > 0">
              <v-col class="text-center mt-6">
                <v-btn
                  elevation="0"
                  class="btn-text"
                  x-large
                  color="primary"
                  @click="dialog = true"
                >
                  <v-icon>{{ icons.mdiPlusCircleOutline }}</v-icon> &nbsp Adicionar Forma de pagamento - &nbsp <b> R$ {{ formatMoney(sumItemsSelectedCustom(customResp.id, customResp.origin)) }} a pagar</b>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <!-- ADICIONAR RESPONSÁVEL PERSONALIZADO -->
    <v-row>
      <v-col>
        <v-card
          outlined
          class="add-responsible-card"
          @click="showDialogAddCustomResponsible()"
        >
          <v-card-title>
            <v-icon
              left
              color="primary"
            >
              {{ icons.mdiAccountPlus }}
            </v-icon>
            Adicionar Responsável Personalizado
          </v-card-title>
          <v-card-text class="text-center">
            Clique para adicionar uma empresa ou pessoa que não está na lista de hóspedes
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- MODAL ESCOLHER TIPO DE PAGAMENTO -->
    <v-dialog
      v-model="dialog"
      max-width="478px"
    >
      <v-card>
        <BarTitleDialog
          :margin_bottom="false"
          title="Escolher pagamento"
          @close="dialog = false"
        >
        </BarTitleDialog>
        <v-row no-gutters>
          <v-col>
            <v-card
              class="btn_payment_methods"
              tile
              block
              elevation="0"
              x-large
              @click="showModalPaymentMoney()"
            >
              <v-row>
                <v-col>
                  <v-icon
                    color="success"
                    x-large
                  >
                    {{ icons.mdiCash }}
                  </v-icon><span
                    class="text_methods"
                  >Dinheiro</span>
                </v-col>
                <v-col class="text-right pt-4">
                  <v-icon> {{ icons.mdiChevronRight }}</v-icon>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col>
            <v-card
              class="btn_payment_methods"
              tile
              block
              elevation="0"
              x-large
              @click="showModalPix()"
            >
              <v-row>
                <v-col>
                  <div class="log_pix">
                    <img
                      width="40"
                      src="@/assets/images/logos/logo-pix.png"
                      alt=""
                    >
                  </div>
                  <div class="text_method_pix">
                    <span>Pix</span>
                  </div>
                </v-col>
                <v-col class="text-right pt-4">
                  <v-icon> {{ icons.mdiChevronRight }}</v-icon>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>

        <v-row no-gutters>
          <v-col>
            <v-card
              class="btn_payment_methods"
              tile
              block
              elevation="0"
              x-large
              @click="showModalCreditCard()"
            >
              <v-row>
                <v-col>
                  <v-icon
                    color="primary"
                    x-large
                  >
                    {{ icons.mdiCreditCard }}
                  </v-icon><span
                    class="text_methods"
                  >Cartão de Crédito</span>
                </v-col>
                <v-col class="text-right pt-4">
                  <v-icon> {{ icons.mdiChevronRight }}</v-icon>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col>
            <v-card
              class="btn_payment_methods"
              tile
              block
              elevation="0"
              x-large
              @click="showModalDebitCard()"
            >
              <v-row>
                <v-col>
                  <v-icon
                    color="success"
                    x-large
                  >
                    {{ icons.mdiCreditCard }}
                  </v-icon><span
                    class="text_methods"
                  >Cartão de Débito</span>
                </v-col>
                <v-col class="text-right pt-4">
                  <v-icon> {{ icons.mdiChevronRight }}</v-icon>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>

        <v-row no-gutters>
          <v-col>
            <v-card
              class="btn_payment_methods"
              tile
              block
              elevation="0"
              x-large
              @click="showModalInvoice()"
            >
              <v-row>
                <v-col>
                  <v-icon
                    color="primary"
                    x-large
                  >
                    {{ icons.mdiCalendarClock }}
                  </v-icon><span
                    class="text_methods"
                  >Faturamento</span>
                </v-col>
                <v-col class="text-right pt-4">
                  <v-icon> {{ icons.mdiChevronRight }}</v-icon>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-card>
      <v-row no-gutters>
        <v-col>
          <v-card
            class="btn_payment_methods"
            tile
            block
            elevation="0"
            x-large
            @click="showModalOther()"
          >
            <v-row>
              <v-col>
                <v-icon
                  color="warning"
                  x-large
                >
                  {{ icons.mdiCurrencyUsd }}
                </v-icon><span
                  class="text_methods"
                >Outros</span>
              </v-col>
              <v-col class="text-right pt-4">
                <v-icon> {{ icons.mdiChevronRight }}</v-icon>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      </v-card>
    </v-dialog>
    <!-- END MODAL ESCOLHER TIPO DE PAGAMENTO -->

    <!-- MODAL PAGAMENTO OUTROS  -->
    <v-dialog
      v-model="dailogOther"
      max-width="500px"
    >
      <v-card>
        <v-row no-gutters>
          <v-col class="bar_top"></v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="2"></v-col>
          <v-col class="text-center text-h6">
            Escolher tipo de pagamento
          </v-col>
          <v-col
            cols="2"
            class="text-right"
          >
            <v-btn
              icon
              @click="dailogOther = false"
            >
              <v-icon> {{ icons.mdiWindowClose }} </v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-card-text>
          <v-row>
            <v-col class="text-left text">
              Valor a pagar
            </v-col>
            <v-col class="text-right text">
              R$ {{ formatMoney(remainingValueSeparate) }}
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <vuetify-money
                v-model="payValueOther"
                :error-messages="validPayValueOther"
                outlined
                label="Valor pago pelo cliente"
              />
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col class="change">
              {{ calcChange }}
            </v-col>
          </v-row>
          <v-row>
            <v-col class="text-right">
              <v-btn
                text
                large
                @click="dailogOther = false"
              >
                Cancelar
              </v-btn>
              <v-btn
                class="ml-2"
                color="primary"
                large
                :disabled="validPayValueOther"
                @click="addPayment()"
              >
                Receber dinheiro
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- END MODAL ESCOLHER VALOR FORMA OUTROS  -->

    <!-- MODAL PAGAMENTO DINHEIRO -->
    <ModalPaymentMoneySeparate v-model="modalPaymentMoney"></ModalPaymentMoneySeparate>
    <!-- END MODAL PAGAMENTO DINHEIRO -->

    <!-- MODAL PAGAMENTO PIX -->
    <ModalPaymentPixSeparate v-model="modalPaymentPix"></ModalPaymentPixSeparate>

    <!-- MODAL PAGAMENTO FATURADO -->
    <ModalPaymentInvoiceSeparate v-model="dailogInvoice"></ModalPaymentInvoiceSeparate>
    <!-- END MODAL PAGAMENTO FATURADO -->

    <!-- MODAL PAGAMENTO DEBITO -->
    <ModalPaymentDebitCardSeparate v-model="modalPaymentDebitCardSeparate" />
    <!-- END MODAL PAGAMENTO DEBITO -->

    <!-- MODAL PAGAMENTO CRDITO -->
    <ModalPaymentCreditCardSeparate v-model="modalPaymentCreditCardSeparate" />
    <!-- END MODAL PAGAMENTO CREDITO -->

    <!-- MODAL ADICIONAR RESPONSÁVEL PERSONALIZADO -->
    <v-dialog
      v-model="dialogCustomResponsible"
      width="800"
    >
      <v-card>
        <BarTitleDialog
          title="Adicionar Responsável Personalizado"
          @close="dialogCustomResponsible = false"
        />
        <v-card-text>
          <v-row no-gutters>
            <v-col class="col-4">
              <v-select
                v-model="customTypeOfPerson"
                label="Tipo de Pessoa"
                outlined
                :items="[{ value: 'PF', text: 'FÍSICA' }, { value: 'PJ', text: 'JURÍDICA' }]"
                @change="customResponsible = ''"
              >
              </v-select>
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col
              v-if="customTypeOfPerson == 'PF'"
              class="col-8"
            >
              <AutocompleteSearchGuest
                v-model="customResponsible"
                @change="loadCustomResponsibleData()"
              ></AutocompleteSearchGuest>
            </v-col>
            <v-col
              v-if="customTypeOfPerson == 'PJ'"
              class="col-8"
            >
              <AutocompleteSearchCompany
                v-model="customResponsible"
                @change="loadCustomResponsibleData()"
              ></AutocompleteSearchCompany>
            </v-col>

            <v-col v-if="customTypeOfPerson == 'PF'">
              <v-text-field
                v-model="customResponsible.cpf"
                v-mask="'###.###.###-##'"
                disabled
                class="ml-2"
                outlined
                label="CPF"
                :hide-details="true"
              ></v-text-field>
            </v-col>
            <v-col v-if="customTypeOfPerson == 'PJ'">
              <v-text-field
                v-model="customResponsible.cpf_cnpj"
                v-mask="'##.###.###/####-##'"
                disabled
                class="ml-2"
                outlined
                label="CPF/CNPJ"
                :hide-details="true"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col>
              <v-text-field
                v-model="customResponsible.address"
                disabled
                outlined
                hide-details
                label="Endereço"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row
            no-gutters
            class="mt-2"
          >
            <v-col cols="3">
              <v-text-field
                v-model="customResponsible.number"
                disabled
                outlined
                hide-details
                label="Número"
              ></v-text-field>
            </v-col>
            <v-col class="ml-2">
              <v-text-field
                v-model="customResponsible.complement"
                disabled
                outlined
                hide-details
                label="Complemento"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row
            no-gutters
            class="mt-2"
          >
            <v-col cols="12">
              <v-text-field
                v-model="customResponsible.neighborhood"
                disabled
                outlined
                hide-details
                label="Bairro"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row
            no-gutters
            class="mt-2"
          >
            <v-col class="">
              <v-text-field
                v-model="customResponsible.zipcode"
                v-mask="'##.###-###'"
                disabled
                outlined
                hide-details
                label="CEP"
              ></v-text-field>
            </v-col>
            <v-col
              cols=""
              class="ml-2"
            >
              <v-text-field
                v-model="cityCustom"
                disabled
                outlined
                label="Cidade"
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row
            no-gutters
            class="mt-2"
          >
            <v-col cols="">
              <v-text-field
                v-model="stateCustom"
                disabled
                outlined
                label="Estado"
                hide-details
              ></v-text-field>
            </v-col>
            <v-col
              cols="6"
              class="ml-2"
            >
              <v-text-field
                v-model="countryCustom"
                disabled
                outlined
                label="Pais"
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row
            no-gutters
            class="mt-2"
          >
            <v-col class="">
              <v-text-field
                v-model="customResponsible.commercial_phone"
                v-mask="'(##)####-####'"
                disabled
                outlined
                hide-details
                label="Fone Com."
              ></v-text-field>
            </v-col>
            <v-col class="ml-2">
              <v-text-field
                v-model="customResponsible.cell_phone"
                v-mask="'(##)#####-####'"
                disabled
                outlined
                hide-details
                label="Celular"
              ></v-text-field>
            </v-col>
            <v-col class="ml-2">
              <v-text-field
                v-model="customResponsible.email"
                disabled
                outlined
                hide-details
                label="Email"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            large
            @click="dialogCustomResponsible = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            large
            :disabled="!customResponsible || customResponsible == ''"
            @click="addCustomResponsible()"
          >
            Adicionar Responsável
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- END MODAL ADICIONAR RESPONSÁVEL PERSONALIZADO -->

    <!-- MSG SAIR DO PAGAMENTO SEPARADO -->
    <v-dialog
      v-model="dialogShowPayment"
      width="500"
    >
      <v-card>
        <BarTitleDialog
          title="Deseja Sair ?"
          @close="dialogShowPayment = false"
        />
        <v-card-text>
          <p class="text">
            Os dados do pagamento separado serão perdidos, deseja continuar?
          </p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-row>
            <v-col class="text-right">
              <v-btn
                text
                large
                @click="dialogShowPayment = false"
              >
                Não
              </v-btn>
              <v-btn
                x-large
                class="ml-2"
                color="primary"
                large
                @click="confirmShowPayment()"
              >
                Sim,
                Sair
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- END MSG SAIR DO PAGAMENTO SEPARADO -->
  </div>
</template>

<script>
import {
  mdiCog,
  mdiChevronLeft,
  mdiChevronRight,
  mdiCash,
  mdiCreditCard,
  mdiCashMultiple,
  mdiCurrencyUsd,
  mdiPlusCircleOutline,
  mdiWindowClose,
  mdiTrashCanOutline,
  mdiCalendarClock,
  mdiAccountPlus,
  mdiStarCircle,
  mdiDelete,
} from '@mdi/js'
import {
  mapActions,
  mapGetters,
  mapMutations,
} from 'vuex'
import ModalPaymentMoneySeparate from './ModalPaymentMoneySeparate.vue'
import ModalPaymentCreditCardSeparate from './ModalPaymentCreditCardSeparate.vue'
import ModalPaymentDebitCardSeparate from './ModalPaymentDebitCardSeparate.vue'
import ModalPaymentInvoiceSeparate from './ModalPaymentInvoiceSeparate.vue'
import ModalPaymentPixSeparate from './ModalPaymentPixSeparate.vue'
import ModalPaymentSeparate from './ModalPaymentPixSeparate.vue'
import BarTitleDialog from '@/components/BarTitleDialog.vue'
import AutocompleteSearchGuest from '@/components/AutocompleteSearchGuest.vue'
import AutocompleteSearchCompany from '@/components/AutocompleteSearchCompany.vue'

export default {
  components: {
    ModalPaymentMoneySeparate,
    BarTitleDialog,
    ModalPaymentPixSeparate,
    ModalPaymentInvoiceSeparate,
    ModalPaymentCreditCardSeparate,
    ModalPaymentDebitCardSeparate,
    AutocompleteSearchGuest,
    AutocompleteSearchCompany,
  },
  data() {
    return {
      modalPaymentDebitCardSeparate: false,
      modalPaymentCreditCardSeparate: false,
      dialogShowPayment: false,
      dailogInvoice: false,
      tabs: null,
      dialog: false,
      dailogOther: false,
      payValueOther: 0,
      valueValid: [],
      modalPaymentMoney: false,
      modalPaymentPix: false,
      parcialBalance: 0,

      // Responsável customizado
      dialogCustomResponsible: false,
      customResponsible: '',
      customTypeOfPerson: 'PF',
      customResponsibles: [],
      cityCustom: '',
      stateCustom: '',
      countryCustom: '',
      icons: {
        mdiPlusCircleOutline,
        mdiChevronLeft,
        mdiCog,
        mdiCash,
        mdiCreditCard,
        mdiCashMultiple,
        mdiCurrencyUsd,
        mdiChevronRight,
        mdiWindowClose,
        mdiTrashCanOutline,
        mdiCalendarClock,
        mdiAccountPlus,
        mdiStarCircle,
        mdiDelete,
      },
    }
  },
  watch: {
    dialog(val) {
      if (val) {

      }
    },
  },
  computed: {
    ...mapGetters('checkout', [
      'remainingValueSeparate',

      //  'getpaymentMethods',
      'getRoom',
      'getItemsCheckout',
      'getSumItemsSelectedCompany',
      'getSelectecResposible',
      'getpaymentMethodsSeparate',
      'getSubTotalSeparateWithTax',

    ]),
    ...mapGetters('config', {
      issRate: 'getIssRate',
    }),

    calcChange() {
      let result = this.payValueOther - this.remainingValueSeparate

      if (Math.sign(result) == -1) { // se = o sinal do numero é negativo
        result *= -1 // invert o sinal
      }

      // se o valor for maior
      if (this.payValueOther < this.remainingValueSeparate) {
        return `Valor restante a ser pago : R$ ${this.formatMoney(result)}`
      }

      // se o valor for igual
      if (this.payValueOther == this.remainingValueSeparate) {
        return 'Sem troco'
      }

      // se o valor for menor
      if (this.payValueOther > this.remainingValueSeparate) {
        return `R$ ${this.formatMoney(result)} de troco`
      }
    },
    validPayValueOther() {
      if (this.payValueOther <= 0) {
        return this.valueValid = ['Quantia deve ser 0.01 ou superior']
      }

      return null
    },
    getGuests() {
      return this.getRoom.current_accommodation.guest
    },
    getCompany() {
      return this.getRoom.current_accommodation.company
    },

    // retorna o total de items selecionado pela empresa
    sumItemsSelectedCompany() {
      const applyISS = this.isAccommodationIssEnabled()

      const result = this.getItemsCheckout.reduce((acc, item) => {
        if (item.responsible) {
          if (item.responsible.origin == 'company' && item.responsible.id == this.getCompany.id) {
            let iss = 0
            let iss_accommodation = 0
            if (item.origin == 'service') {
              iss = ((parseFloat(item.iss) / 100) * parseFloat(item.sale_price)) * parseFloat(item.pivot.quantity)
            }

            // iss de hospedagem
            if (item.origin == 'accommodation' && applyISS) {
              iss_accommodation = this.issRate * parseFloat(item.sale_price)
            }

            return acc + parseFloat(item.sale_price) * parseFloat(item.pivot.quantity) + iss + iss_accommodation
          }

          return acc
        }

        return acc
      }, 0)

      return result
    },
    sumISSCompany() {
      const applyISS = this.isAccommodationIssEnabled()
      if (!applyISS) {
        return 0
      }
      const result = this.getItemsCheckout.reduce((acc, item) => {
        if (item.responsible) {
          if (item.responsible.origin == 'company' && item.responsible.id == this.getCompany.id) {
            let iss = 0
            let iss_accommodation = 0
            if (item.origin == 'service') {
              iss = ((parseFloat(item.iss) / 100) * parseFloat(item.sale_price)) * parseFloat(item.pivot.quantity)
            }

            // iss de hospedagem
            if (item.origin == 'accommodation' && applyISS) {
              iss_accommodation = this.issRate * parseFloat(item.sale_price)
            }

            return acc + iss + iss_accommodation
          }

          return acc
        }

        return acc
      }, 0)

      return result
    },

    // lista de itens selecionado pela company
    itemsSelectedCompany() {
      const result = this.getItemsCheckout.filter(item => {
        if (item.responsible) {
          return item.responsible.origin == 'company' && item.responsible.id == this.getCompany.id
        }
      })

      return result
    },

  },
  methods: {
    ...mapMutations('checkout', ['setStage',
      'addPaymentMethod',
      'removePaymentMethod',
      'setSelectecResposible',
      'removePaymentMethodSeparate',
      'clearCheckoutSeparete',
    ]),
    ...mapActions('company', ['getCompanyCredit']),

    // lista de itens selecionado para cada hospede
    itemsSelectedGuests(guest_id) {
      const result = this.getItemsCheckout.filter(item => {
        if (item.responsible) {
          return item.responsible.origin == 'guest' && item.responsible.id == guest_id
        }
      })

      return result
    },

    // retorna o total de items selecionado guest
    sumItemsSelectedGuests(guest_id) {
      const applyISS = this.isAccommodationIssEnabled()
      const result = this.getItemsCheckout.reduce((acc, item) => {
        if (item.responsible) {
          if (item.responsible.origin == 'guest' && item.responsible.id == guest_id) {
            let iss = 0
            let iss_accommodation = 0
            if (item.origin == 'service') {
              iss = ((parseFloat(item.iss) / 100) * parseFloat(item.sale_price)) * parseFloat(item.pivot.quantity)
            }

            // iss de hospedagem
            if (item.origin == 'accommodation' && applyISS) {
              iss_accommodation = this.issRate * parseFloat(item.sale_price)
            }

            return acc + parseFloat(item.sale_price) * parseFloat(item.pivot.quantity) + iss + iss_accommodation
          }

          return acc
        }

        return acc
      }, 0)

      return result
    },
    sumISSPerGuests(guest_id) {
      const applyISS = this.isAccommodationIssEnabled()
      if (!applyISS) {
        return 0
      }

      const result = this.getItemsCheckout.reduce((acc, item) => {
        if (item.responsible) {
          if (item.responsible.origin == 'guest' && item.responsible.id == guest_id) {
            let iss = 0
            let iss_accommodation = 0
            if (item.origin == 'service') {
              iss = ((parseFloat(item.iss) / 100) * parseFloat(item.sale_price)) * parseFloat(item.pivot.quantity)
            }

            // iss de hospedagem
            if (item.origin == 'accommodation' && applyISS) {
              iss_accommodation = this.issRate * parseFloat(item.sale_price)
            }

            return acc + iss + iss_accommodation
          }

          return acc
        }

        return acc
      }, 0)

      return result
    },

    // seleciona a company para atribuicao dos items de checkout
    setResponsibleCompany(company) {
      company.origin = 'company'
      this.setSelectecResposible(company)
    },

    setResponsibleGuest(guest) {
      guest.origin = 'guest'
      this.setSelectecResposible(guest)
    },
    showModalCreditCard() {
      this.dialog = false
      this.modalPaymentCreditCardSeparate = true
    },
    showModalDebitCard() {
      this.dialog = false
      this.modalPaymentDebitCardSeparate = true
    },
    showModalPaymentMoney() {
      this.dialog = false
      this.modalPaymentMoney = true
    },
    showModalOther() {
      this.dialog = false
      this.dailogOther = true
    },
    async showModalInvoice() {
      const company = this.getCompany
      if (company?.id && company?.allow_billing) {
        try {
          const response = await this.getCompanyCredit(company.id)
          const data = response?.data?.data || {}
          if (data.billing_blocked) {
            this.$swal({
              icon: 'error',
              title: 'Faturamento Bloqueado',
              html: `Esta empresa possui faturas vencidas há <strong>${data.overdue_days || 0} dias</strong>. Faturamento bloqueado.`,
              confirmButtonColor: '#FF4C51',
            })

            return
          }
        } catch (e) { /* deixa o backend rejeitar */ }
      }
      this.dialog = false
      this.dailogInvoice = true
    },
    showModalPix() {
      this.dialog = false
      this.modalPaymentPix = true
    },
    showGratuity() {
      this.setStage('gratuity')
    },
    showPayment() {
      this.dialogShowPayment = true
    },
    confirmShowPayment() {
      this.clearCheckoutSeparete()
      this.setStage('payment')
    },
    formatMoney(value) {
      return value.toLocaleString('PT-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    },

    // metodos dialog other
    addPayment() {
      const payment = {
        method: 'other',
        value: this.payValueOther,
      }

      this.addPaymentMethod(payment)
      this.dailogOther = false
    },

    removePayment(payment) {
      if (payment.is_partial || payment.partial) {
        this.$toast.info('Este pagamento já foi registrado anteriormente e não pode ser removido por esta tela.')

        return
      }

      this.removePaymentMethodSeparate(payment)
    },

    // Métodos para responsáveis customizados
    showDialogAddCustomResponsible() {
      this.dialogCustomResponsible = true
      this.customResponsible = ''
      this.customTypeOfPerson = 'PF'
      this.cityCustom = ''
      this.stateCustom = ''
      this.countryCustom = ''
    },

    loadCustomResponsibleData() {
      if (this.customResponsible && this.customResponsible.city) {
        this.cityCustom = this.customResponsible.city.name
        this.stateCustom = this.customResponsible.state.name
        this.countryCustom = this.customResponsible.country.name
      }
    },

    addCustomResponsible() {
      if (!this.customResponsible || this.customResponsible == '') {
        this.$toast.error('Selecione uma empresa ou pessoa')

        return
      }

      // Define origin como 'guest' ou 'company' (igual aos responsáveis normais)
      const origin = this.customTypeOfPerson == 'PF' ? 'guest' : 'company'

      // Verifica se já foi adicionado
      const alreadyExists = this.customResponsibles.find(r => r.id === this.customResponsible.id
                && r.origin === origin)

      if (alreadyExists) {
        this.$toast.warning('Este responsável já foi adicionado')

        return
      }

      const responsible = {
        ...this.customResponsible,
        origin, // 'guest' ou 'company' (compatível com backend)
        is_custom: true, // Flag apenas para UI (não enviado ao backend)
      }

      this.customResponsibles.push(responsible)
      this.dialogCustomResponsible = false
      this.$toast.success('Responsável adicionado com sucesso')
    },

    removeCustomResponsible(index) {
      // Verifica se tem itens atribuídos
      const responsible = this.customResponsibles[index]
      const hasItems = this.getItemsCheckout.some(item => item.responsible
                && item.responsible.id === responsible.id
                && item.responsible.origin === responsible.origin)

      if (hasItems) {
        this.$swal({
          title: 'Atenção!',
          text: 'Este responsável possui itens atribuídos. Deseja realmente remover?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Sim, remover',
          cancelButtonText: 'Cancelar',
        }).then(result => {
          if (result.isConfirmed) {
            // Remove atribuições dos itens
            this.getItemsCheckout.forEach(item => {
              if (item.responsible
                                && item.responsible.id === responsible.id
                                && item.responsible.origin === responsible.origin) {
                item.responsible = null
              }
            })
            this.customResponsibles.splice(index, 1)
            this.$toast.success('Responsável removido')
          }
        })
      } else {
        this.customResponsibles.splice(index, 1)
        this.$toast.success('Responsável removido')
      }
    },

    setResponsibleCustom(customResp) {
      const responsible = {
        ...customResp,
        origin: customResp.origin,
      }
      this.setSelectecResposible(responsible)
    },

    // lista de itens selecionado para cada responsável customizado
    itemsSelectedCustom(id, origin) {
      const result = this.getItemsCheckout.filter(item => {
        if (item.responsible) {
          return item.responsible.origin == origin && item.responsible.id == id
        }
      })

      return result
    },

    // retorna o total de items selecionado para responsável customizado
    sumItemsSelectedCustom(id, origin) {
      const applyISS = this.isAccommodationIssEnabled()
      const result = this.getItemsCheckout.reduce((acc, item) => {
        if (item.responsible) {
          if (item.responsible.origin == origin && item.responsible.id == id) {
            let iss = 0
            let iss_accommodation = 0
            if (item.origin == 'service') {
              iss = ((parseFloat(item.iss) / 100) * parseFloat(item.sale_price)) * parseFloat(item.pivot.quantity)
            }

            // iss de hospedagem
            if (item.origin == 'accommodation' && applyISS) {
              iss_accommodation = this.issRate * parseFloat(item.sale_price)
            }

            return acc + parseFloat(item.sale_price) * parseFloat(item.pivot.quantity) + iss + iss_accommodation
          }

          return acc
        }

        return acc
      }, 0)

      return result
    },

    sumISSCustom(id, origin) {
      const applyISS = this.isAccommodationIssEnabled()
      if (!applyISS) {
        return 0
      }

      const result = this.getItemsCheckout.reduce((acc, item) => {
        if (item.responsible) {
          if (item.responsible.origin == origin && item.responsible.id == id) {
            let iss = 0
            let iss_accommodation = 0
            if (item.origin == 'service') {
              iss = ((parseFloat(item.iss) / 100) * parseFloat(item.sale_price)) * parseFloat(item.pivot.quantity)
            }

            // iss de hospedagem
            if (item.origin == 'accommodation' && applyISS) {
              iss_accommodation = this.issRate * parseFloat(item.sale_price)
            }

            return acc + iss + iss_accommodation
          }

          return acc
        }

        return acc
      }, 0)

      return result
    },

    isAccommodationIssEnabled() {
      const withIss = this.getRoom?.current_accommodation?.with_iss

      return withIss === true || withIss === 1 || withIss === '1' || withIss === 'yes' || withIss === 'true' || withIss === 'sim'
    },

  },
}
</script>

<style scoped>
.card_selected {
    border: solid #16b1ff 4px;

}

.log_pix {
    width: 40px;
    float: left;

}

.text_method_pix {
    color: black;
    margin-top: 8px;
}

.card {
    height: 100px;
    cursor: pointer;
}

.card:hover {
    background: rgb(248, 248, 248);
}

.text_card {
    color: black;
    font-size: 16px;
}

.title {
    color: black;
    font-size: 25px;
}

.btn_payment_methods {
    border-top: 1px solid #eeeeee;
    height: 81px;
    width: 478px;
    padding-top: 21px;
    padding-left: 20px;
    padding-right: 20px;
    cursor: pointer;
}

.btn_payment_methods:hover {
    background: rgb(248, 248, 248);
}

.span {
    margin-top: 10px;
}

.text_methods {
    color: black;
}

.text {
    color: black;
    font-size: large;
}

.change {
    color: blueviolet;
    font-size: medium;
}

.add-responsible-card {
    cursor: pointer;
    border: 2px dashed #1976d2;
    transition: all 0.3s ease;
}

.add-responsible-card:hover {
    background: #e3f2fd;
    border-color: #1565c0;
}
</style>
